/**
 * Branding Configuration — White-Label Support
 *
 * Set ENABLE_WHITE_LABEL to true and customize WHITE_LABEL_CONFIG
 * to rebrand the entire application.
 *
 * When ENABLE_WHITE_LABEL is false, the default Maverick Ignite
 * branding is used (zero breaking change).
 *
 * Note: Some branding requires manual file edits (not auto-configurable):
 * - index.html: Title, meta tags, OG tags, author
 * - public/manifest.json: PWA name, description
 * - public/favicon.*: Favicons (replace image files)
 * - public/logo.png: Product logo (replace file, or use productLogoUrl for runtime)
 * - public/maverick-logo*.png: Company logos (replace files, or use companyLogoUrl for runtime)
 */

const ENABLE_WHITE_LABEL = false; // Set to true to activate white-labeling

const WHITE_LABEL_CONFIG = {
  // Product Identity
  productName: 'QuickPOS - Dine',       // e.g., "FoodFlow POS"
  productTagline: 'Restaurant Management System',
  productVersion: 'v2.0',

  // Company Identity (the "Powered by" entity)
  companyName: 'Quick POS Solutions',       // e.g., "Acme Solutions"
  companyLogoUrl: '/whitelabel/company-logo.png',
  companyLogoWhiteUrl: '/whitelabel/company-logo-white.png',
  companyWebsite: 'https://quickpossolutions.com',
  supportEmail: 'support@quickpossolutions.com',
  copyrightYear: '2026',

  // Product Logo (shown on login, headers)
  productLogoUrl: '/whitelabel/product-logo.png',

  // Receipt Branding
  receiptPoweredBy: 'Powered by Quick POS Solutions',
  receiptFallbackName: 'Quick POS Solutions',

  // Printer Config
  printerPoweredBy: 'A Product by Quick POS Solutions',
};

// === DEFAULT (Maverick Ignite) branding — DO NOT EDIT ===
const DEFAULT_CONFIG = {
  productName: 'Maverick Dine',
  productTagline: 'Restaurant Management System',
  productVersion: 'v2.0',
  companyName: 'Maverick Ignite',
  companyLogoUrl: '/maverick-logo.png',
  companyLogoWhiteUrl: '/maverick-logo-white.png',
  companyWebsite: 'https://maverickignite.com',
  supportEmail: 'support@maverickignite.com',
  copyrightYear: '2025',
  productLogoUrl: '/logo.png',
  receiptPoweredBy: 'Powered by Maverick Ignite',
  receiptFallbackName: 'MAVERICK DINE',
  printerPoweredBy: 'A Product by Maverick Ignite',
};

export { ENABLE_WHITE_LABEL, WHITE_LABEL_CONFIG, DEFAULT_CONFIG };
export default ENABLE_WHITE_LABEL ? WHITE_LABEL_CONFIG : DEFAULT_CONFIG;
